import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {DomainUrlService} from '../../../application/config/domain-url.service';
import {Account} from '../model/account';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  readonly searchAccountUrl = this.domainUrlService.getOptimPortalBackApiUrl() + '/rest/public/v1/account/search/';

  constructor(private http: HttpClient, private domainUrlService: DomainUrlService) {
  }

  search(filter: string): Observable<Array<Account>> {
    return this.http.get(this.searchAccountUrl + filter) as Observable<Array<Account>>;
  }

  getAccountLogo(account: Account | undefined): string {
    if (account === undefined) {
      return '';
    }
    return `${this.domainUrlService.getRepositoryApiUrl()}/rest/public/v2/accounts/${account.accountId}/logo`;
  }
}
